const MEILISEARCH_HOST = "https://ms-69223ce62f2d-106.lon.meilisearch.io"
const MEILISEARCH_API_KEY = "2969134b46109f7a8d0330f6d1655d9c65c84752ac130674859feeefdf216f25"

export {
  MEILISEARCH_HOST,
  MEILISEARCH_API_KEY
}
